/** Tenants with a dedicated GIS autocomplete backend (not Address Sense). */
export const DEDICATED_GIS_TENANT_IDS = ['thn', 'swp', 'evi'] as const;

export type DedicatedGisTenantId = (typeof DEDICATED_GIS_TENANT_IDS)[number];

export function hasDedicatedGisIntegration(tenantId: string): boolean {
  return DEDICATED_GIS_TENANT_IDS.includes(tenantId?.toLowerCase() as DedicatedGisTenantId);
}
